import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from '../../components/modals/DefaultModal';


function ProgramaModal({ show, onHide, programa, onSuccess }) {
  const [formData, setFormData] = useState({
    cnpjAssociacao: '',
    id: '',
    descricao: '',
    situacao: true,
  });
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (!show) {
      setFormData({
        cnpjAssociacao: cnpj,
        id: '',
        descricao: '',
        situacao: true,
      });
    } else if (programa) {
      setFormData({
        ...programa,
        descricao: programa.descricao ? programa.descricao.toUpperCase() : '',
        situacao: programa.situacao !== undefined ? programa.situacao : true,
      });
    } else {
      setFormData({
        cnpjAssociacao: cnpj,
        id: '',
        descricao: '',
        situacao: true,
      });
    }
  }, [show, programa]);

  function handleChange(event) {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value.toUpperCase(),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    const programaParaSalvar = {
      ...formData,
      cnpjAssociacao: cnpj,
    };

    axios
      .post(`${API_BASE_URL.PROGRAMA}/save`, programaParaSalvar, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        // Fechar o modal primeiro
        onHide();
        // Depois mostrar a mensagem de sucesso
        showDefaultModal('success', 'O registro foi salvo com sucesso!', () => {
          onSuccess();
        });
      })
      .catch(error => {
        console.error('Erro ao salvar programa:', error);
        showDefaultModal('error', 'Erro ao salvar o registro!');
      });
  }

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header
          closeButton
          className={
            programa ? 'bg-primary text-white' : 'bg-success text-white'
          }
          style={{ height: '30px' }}
        >
          <Modal.Title className="fs-5">
            {programa ? 'Editar Programa' : 'Novo Programa'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-12 input-group-sm">
                <label className="form-label">Nome</label>
                <input
                  onChange={handleChange}
                  value={formData.descricao}
                  name="descricao"
                  type="text"
                  className="form-control text-uppercase" // Adiciona classe para exibir em maiúsculas
                  required
                />
              </div>

              <div className="col-md-12 input-group-sm">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="situacaoCheckbox"
                    name="situacao"
                    checked={formData.situacao}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor="situacaoCheckbox">
                    Vigente
                  </label>
                </div>
              </div>

              <div className="col-md-12 mb-3 input-group-sm d-flex justify-content-end">
                <Button variant="danger" onClick={onHide} className="mx-1">
                  <i className="bi bi-x-lg" /> Cancelar
                </Button>
                <Button type="submit" variant="success" className="mx-1">
                  <i className="bi bi-check-lg" /> Salvar
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default ProgramaModal;
